// @generated by protoc-gen-connect-es v1.4.0 with parameter "target=ts"
// @generated from file gitpod/v1/project.proto (package gitpod.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { CreateProjectFromEnvironmentRequest, CreateProjectFromEnvironmentResponse, CreateProjectPolicyRequest, CreateProjectPolicyResponse, CreateProjectRequest, CreateProjectResponse, DeleteProjectPolicyRequest, DeleteProjectPolicyResponse, DeleteProjectRequest, DeleteProjectResponse, GetProjectRequest, GetProjectResponse, ListProjectPoliciesRequest, ListProjectPoliciesResponse, ListProjectsRequest, ListProjectsResponse, UpdateProjectPolicyRequest, UpdateProjectPolicyResponse, UpdateProjectRequest, UpdateProjectResponse } from "./project_pb.js";
import { MethodIdempotency, MethodKind } from "@bufbuild/protobuf";

/**
 * @generated from service gitpod.v1.ProjectService
 */
export const ProjectService = {
  typeName: "gitpod.v1.ProjectService",
  methods: {
    /**
     * Creates a new project with specified configuration.
     *
     * Use this method to:
     * - Set up development projects
     * - Configure project environments
     * - Define project settings
     * - Initialize project content
     *
     * ### Examples
     *
     * - Create basic project:
     *
     *   Creates a project with minimal configuration.
     *
     *   ```yaml
     *   name: "Web Application"
     *   environmentClass:
     *     environmentClassId: "d2c94c27-3b76-4a42-b88c-95a85e392c68"
     *   initializer:
     *     specs:
     *       - git:
     *           remoteUri: "https://github.com/org/repo"
     *   ```
     *
     * - Create project with devcontainer:
     *
     *   Creates a project with custom development container.
     *
     *   ```yaml
     *   name: "Backend Service"
     *   environmentClass:
     *     environmentClassId: "d2c94c27-3b76-4a42-b88c-95a85e392c68"
     *   initializer:
     *     specs:
     *       - git:
     *           remoteUri: "https://github.com/org/backend"
     *   devcontainerFilePath: ".devcontainer/devcontainer.json"
     *   automationsFilePath: ".gitpod/automations.yaml"
     *   ```
     *
     * @generated from rpc gitpod.v1.ProjectService.CreateProject
     */
    createProject: {
      name: "CreateProject",
      I: CreateProjectRequest,
      O: CreateProjectResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Creates a new project using an existing environment as a template.
     *
     * Use this method to:
     * - Clone environment configurations
     * - Create projects from templates
     * - Share environment setups
     *
     * ### Examples
     *
     * - Create from environment:
     *
     *   Creates a project based on existing environment.
     *
     *   ```yaml
     *   name: "Frontend Project"
     *   environmentId: "07e03a28-65a5-4d98-b532-8ea67b188048"
     *   ```
     *
     * @generated from rpc gitpod.v1.ProjectService.CreateProjectFromEnvironment
     */
    createProjectFromEnvironment: {
      name: "CreateProjectFromEnvironment",
      I: CreateProjectFromEnvironmentRequest,
      O: CreateProjectFromEnvironmentResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Gets details about a specific project.
     *
     * Use this method to:
     * - View project configuration
     * - Check project status
     * - Get project metadata
     *
     * ### Examples
     *
     * - Get project details:
     *
     *   Retrieves information about a specific project.
     *
     *   ```yaml
     *   projectId: "b0e12f6c-4c67-429d-a4a6-d9838b5da047"
     *   ```
     *
     * @generated from rpc gitpod.v1.ProjectService.GetProject
     */
    getProject: {
      name: "GetProject",
      I: GetProjectRequest,
      O: GetProjectResponse,
      kind: MethodKind.Unary,
      idempotency: MethodIdempotency.NoSideEffects,
    },
    /**
     * Updates a project's configuration.
     *
     * Use this method to:
     * - Modify project settings
     * - Update environment class
     * - Change project name
     * - Configure initializers
     *
     * ### Examples
     *
     * - Update project name:
     *
     *   Changes the project's display name.
     *
     *   ```yaml
     *   projectId: "b0e12f6c-4c67-429d-a4a6-d9838b5da047"
     *   name: "New Project Name"
     *   ```
     *
     * - Update environment class:
     *
     *   Changes the project's environment class.
     *
     *   ```yaml
     *   projectId: "b0e12f6c-4c67-429d-a4a6-d9838b5da047"
     *   environmentClass:
     *     environmentClassId: "d2c94c27-3b76-4a42-b88c-95a85e392c68"
     *   ```
     *
     * @generated from rpc gitpod.v1.ProjectService.UpdateProject
     */
    updateProject: {
      name: "UpdateProject",
      I: UpdateProjectRequest,
      O: UpdateProjectResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Lists projects with optional filtering.
     *
     * Use this method to:
     * - View all accessible projects
     * - Browse project configurations
     * - Monitor project status
     *
     * ### Examples
     *
     * - List projects:
     *
     *   Shows all projects with pagination.
     *
     *   ```yaml
     *   pagination:
     *     pageSize: 20
     *   ```
     *
     * @generated from rpc gitpod.v1.ProjectService.ListProjects
     */
    listProjects: {
      name: "ListProjects",
      I: ListProjectsRequest,
      O: ListProjectsResponse,
      kind: MethodKind.Unary,
      idempotency: MethodIdempotency.NoSideEffects,
    },
    /**
     * Deletes a project permanently.
     *
     * Use this method to:
     * - Remove unused projects
     * - Clean up test projects
     * - Delete obsolete configurations
     *
     * ### Examples
     *
     * - Delete project:
     *
     *   Permanently removes a project.
     *
     *   ```yaml
     *   projectId: "b0e12f6c-4c67-429d-a4a6-d9838b5da047"
     *   ```
     *
     * @generated from rpc gitpod.v1.ProjectService.DeleteProject
     */
    deleteProject: {
      name: "DeleteProject",
      I: DeleteProjectRequest,
      O: DeleteProjectResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Lists policies for a project.
     *
     * Use this method to:
     * - View access controls
     * - Check policy configurations
     * - Audit permissions
     *
     * ### Examples
     *
     * - List policies:
     *
     *   Shows all policies for a project.
     *
     *   ```yaml
     *   projectId: "b0e12f6c-4c67-429d-a4a6-d9838b5da047"
     *   pagination:
     *     pageSize: 20
     *   ```
     *
     * @generated from rpc gitpod.v1.ProjectService.ListProjectPolicies
     */
    listProjectPolicies: {
      name: "ListProjectPolicies",
      I: ListProjectPoliciesRequest,
      O: ListProjectPoliciesResponse,
      kind: MethodKind.Unary,
      idempotency: MethodIdempotency.NoSideEffects,
    },
    /**
     * Creates a new policy for a project.
     *
     * Use this method to:
     * - Set up access controls
     * - Define group permissions
     * - Configure role-based access
     *
     * ### Examples
     *
     * - Create admin policy:
     *
     *   Grants admin access to a group.
     *
     *   ```yaml
     *   projectId: "b0e12f6c-4c67-429d-a4a6-d9838b5da047"
     *   groupId: "f53d2330-3795-4c5d-a1f3-453121af9c60"
     *   role: PROJECT_ROLE_ADMIN
     *   ```
     *
     * @generated from rpc gitpod.v1.ProjectService.CreateProjectPolicy
     */
    createProjectPolicy: {
      name: "CreateProjectPolicy",
      I: CreateProjectPolicyRequest,
      O: CreateProjectPolicyResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Deletes a project policy.
     *
     * Use this method to:
     * - Remove access controls
     * - Revoke permissions
     * - Clean up policies
     *
     * ### Examples
     *
     * - Delete policy:
     *
     *   Removes a group's access policy.
     *
     *   ```yaml
     *   projectId: "b0e12f6c-4c67-429d-a4a6-d9838b5da047"
     *   groupId: "f53d2330-3795-4c5d-a1f3-453121af9c60"
     *   ```
     *
     * @generated from rpc gitpod.v1.ProjectService.DeleteProjectPolicy
     */
    deleteProjectPolicy: {
      name: "DeleteProjectPolicy",
      I: DeleteProjectPolicyRequest,
      O: DeleteProjectPolicyResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Updates an existing project policy.
     *
     * Use this method to:
     * - Modify access levels
     * - Change group roles
     * - Update permissions
     *
     * ### Examples
     *
     * - Update policy role:
     *
     *   Changes a group's access level.
     *
     *   ```yaml
     *   projectId: "b0e12f6c-4c67-429d-a4a6-d9838b5da047"
     *   groupId: "f53d2330-3795-4c5d-a1f3-453121af9c60"
     *   role: PROJECT_ROLE_EDITOR
     *   ```
     *
     * @generated from rpc gitpod.v1.ProjectService.UpdateProjectPolicy
     */
    updateProjectPolicy: {
      name: "UpdateProjectPolicy",
      I: UpdateProjectPolicyRequest,
      O: UpdateProjectPolicyResponse,
      kind: MethodKind.Unary,
    },
  }
} as const;

